exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".followStoreButton__button___3R-_b {\n  background-color: #f94144;\n  color: white;\n  border: 1px solid #f94144;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s ease; }\n  .followStoreButton__button___3R-_b:hover:not(:disabled) {\n    opacity: 0.9; }\n  .followStoreButton__button___3R-_b:disabled {\n    cursor: not-allowed;\n    opacity: 0.6; }\n\n.followStoreButton__buttonActive___2-wtT {\n  background-color: white;\n  color: #3f3f3f;\n  border-color: #d0d0d0; }\n  .followStoreButton__buttonActive___2-wtT:hover:not(:disabled) {\n    opacity: 1;\n    border-color: #f94144;\n    color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"button": "followStoreButton__button___3R-_b",
	"buttonActive": "followStoreButton__buttonActive___2-wtT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FollowStoreButton/followStoreButton.scss
// module id = 4236
// module chunks = 6